import { create } from 'zustand'

const useDevMenuStore = create((set) => ({
	isDevMenuOpen: false,
	toggleDevMenu: () => set((state) => ({ isDevMenuOpen: !state.isDevMenuOpen })),
	setDevMenu: (isOpen) => set((state) => ({ isDevMenuOpen: isOpen })),
}))

export default useDevMenuStore;